import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  commodityClassification: null,
  exportStatus: { loading: false, error: null },
}

const commodityClassificationSlice = createSlice({
  name: "commodityClassification",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setCommodityClassification(state, action) {
      state.commodityClassification = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.commodityClassification = null
      state.exportStatus = { loading: false, error: null }
    },
  },
})

export const commodityClassificationAction = commodityClassificationSlice.actions

export default commodityClassificationSlice
